export const QUESTION_TEXT = {
  JP: {
    hero: {
      subTitle: "FAQ",
      title: "よくあるご質問",
      description:
        "初めての方にも安心してご参加いただけるよう、よくいただくご質問をまとめました。",
    },
    openLabel: "FAQを開く",
    items: [
      {
        key: "recommended",
        question: "どんな方におすすめですか？",
        answer:
          "写真や映像にこだわりたい方、女子旅、特別な宮古島体験をしたい方、全てを忘れて非日常体験を味わいたい方に向けたツアーです。一般的な観光ではなく、美しい景色や特別なロケーションで、一生残る思い出を写真や映像として残したい方におすすめしています。",
      },
      {
        key: "difference",
        question: "他のツアーとの違いはなんですか？",
        answer:
          "当ツアーでは、全てプロ仕様の機材を使用しています。世界中の人を撮影してきたプロカメラマンが、画角・光・時間帯・シャッタースピードなど細部までこだわりながら撮影を行っています。SNSでよく見るような量産型の映像ではなく、“ここでしか撮れない空気感”を大切にしています。",
      },
      {
        key: "qualityGuarantee",
        question: "撮影品質保証とはなんですか？",
        answer:
          "当日の天候や海況を確認し、十分な撮影コンディションでご案内できないと判断した場合は、キャンセル料無料で中止または日程変更をご提案します。安心してご予約ください。",
      },
      {
        key: "whyCreated",
        question: "なぜこのツアーを作ったのですか？",
        answer:
          "宮古島には素晴らしいツアーがたくさんありますが、撮影クオリティにここまでこだわったツアーはないと思い勿体無いと感じたからです。宮古島の海、光、空気感には本来もっと大きなポテンシャルがあると思っています。その魅力を最大限に引き出し、ここでしか撮れない体験を作りたいと思い、このツアーを始めました。",
      },
      {
        key: "ageLimit",
        question: "年齢制限はありますか？",
        answer:
          "サーフィン体験以外は、ツアーの世界観や体験コンセプト維持のため、20歳〜40歳の方を対象とさせていただいております。",
      },
      {
        key: "children",
        question: "子供も参加できますか？",
        answer:
          "申し訳ありません。サーフィン体験以外は、大人向けの体験・撮影をコンセプトとしているため、お子様のご参加はご遠慮いただいております。",
      },
      {
        key: "delivery",
        question: "写真・映像データはいつもらえますか？",
        answer:
          "撮影データは当日AirDropにてお渡し可能です。編集が必要なデータについては、1日以内にオンラインダウンロードURLをお送りします。",
      },
      {
        key: "rain",
        question: "雨の日はどうなりますか？",
        answer:
          "当日の海況や天候を確認したうえで、十分な撮影クオリティでご案内することが難しいと判断した場合は、ツアーを中止または日程変更とさせていただく場合がございます。その際のキャンセル料は発生いたしません。",
      },
      {
        key: "pickup",
        question: "送迎はありますか？",
        answer: "宮古島内であればホテル・空港周辺まで送迎可能です。",
      },
      {
        key: "bring",
        question: "持ち物は何が必要ですか？",
        answer: "水着・タオル・サンダル・日焼け止めをご用意ください。",
      },
      {
        key: "cancel",
        question: "キャンセル料について",
        answer:
          "各ツアー詳細ページの注意事項をご確認ください。天候などの影響でこちらからキャンセルさせていただく場合はキャンセル料無料となります。",
      },
      {
        key: "payment",
        question: "お支払いについて",
        answer:
          "ツアーの当日に現金でお支払いください。現状現金のみのお取り扱いとなっております。",
      },
    ],
    cta: {
      lines: [
        "その他ご不明点はお気軽にご相談ください",
        "LINE・Instagram DMよりご予約、ご相談を承っております。",
        "通常1時間以内に返信します。(ツアー中は終わり次第ご連絡させていただきます。)",
      ],
      buttons: {
        line: "LINEで相談する",
        instagram: "Instagramで相談する",
      },
    },
  },

  EN: {
    hero: {
      subTitle: "FAQ",
      title: "Frequently Asked Questions",
      description:
        "We have gathered common questions so first-time guests can join with confidence.",
    },
    openLabel: "Open FAQ",
    items: [
      {
        key: "recommended",
        question: "Who is this tour recommended for?",
        answer:
          "This tour is perfect for guests who care about beautiful photos and videos, girls’ trips, solo travelers, anyone looking for a special Miyako Island experience, and those who want to forget everyday life and enjoy something extraordinary. Rather than a standard sightseeing tour, it is designed for those who want to capture unforgettable memories in beautiful scenery and unique locations.",
      },
      {
        key: "difference",
        question: "What makes this tour different from other tours?",
        answer:
          "We use professional-level equipment for every shoot. A professional photographer who has captured guests from around the world carefully considers composition, light, timing, shutter speed, and every small detail. Instead of generic social media-style content, we focus on capturing the atmosphere that can only be found here.",
      },
      {
        key: "qualityGuarantee",
        question: "What is the shooting condition guarantee?",
        answer:
          "We check the weather and sea conditions on the day. If we decide that the shooting conditions are not suitable, we will cancel or suggest rescheduling with no cancellation fee.",
      },
      {
        key: "whyCreated",
        question: "Why did you create this tour?",
        answer:
          "Miyako Island already has many wonderful tours, but we felt there was room for a tour that focuses deeply on shooting quality. The ocean, light, and atmosphere of Miyako Island have incredible potential. We created this tour to bring out that beauty and offer an experience that can only be captured here.",
      },
      {
        key: "ageLimit",
        question: "Is there an age limit?",
        answer:
          "Except for the surfing experience, our tours are for guests aged 20 to 40 to maintain the concept and atmosphere of the experience.",
      },
      {
        key: "children",
        question: "Can children join the tour?",
        answer:
          "We are sorry, but except for the surfing experience, our tours are designed as adult-focused experiences and shoots, so children cannot join.",
      },
      {
        key: "delivery",
        question: "When will I receive the photo and video data?",
        answer:
          "Shooting data can be shared by AirDrop on the same day. Edited data will be sent via an online download URL within 2 to 3 days.",
      },
      {
        key: "rain",
        question: "What happens if it rains?",
        answer:
          "We will check the sea and weather conditions on the day. If we decide that it is difficult to provide the tour with enough shooting quality, the tour may be canceled or rescheduled. In that case, there will be no cancellation fee.",
      },
      {
        key: "pickup",
        question: "Do you provide pickup service?",
        answer:
          "Pickup is available around hotels and the airport area within Miyako Island.",
      },
      {
        key: "bring",
        question: "What should I bring?",
        answer: "Please bring a swimsuit, towel, sandals, and sunscreen.",
      },
      {
        key: "cancel",
        question: "What is the cancellation policy?",
        answer:
          "Please check the notes on each tour detail page. If we cancel the tour due to weather or sea conditions, there will be no cancellation fee.",
      },
      {
        key: "payment",
        question: "How can I pay?",
        answer:
          "Please pay in cash on the day of the tour. Currently, we only accept cash payments.",
      },
    ],
    cta: {
      lines: [
        "Feel free to contact us if you have any other questions.",
        "Reservations and inquiries are available via LINE or Instagram DM.",
        "We usually reply within 1 hour. If we are on a tour, we will reply as soon as it finishes.",
      ],
      buttons: {
        line: "Contact us on LINE",
        instagram: "Contact us on Instagram",
      },
    },
  },

  中文: {
    hero: {
      subTitle: "FAQ",
      title: "常见问题",
      description: "为了让第一次参加的客人也能安心预约，我们整理了常见问题。",
    },
    openLabel: "打开常见问题",
    items: [
      {
        key: "recommended",
        question: "这个行程适合什么样的人？",
        answer:
          "本行程适合重视照片和视频质量、女生旅行、独自旅行、想在宫古岛体验特别回忆，以及想暂时忘记日常、享受非日常体验的客人。它不是普通观光行程，而是适合想在美丽风景和特别地点留下珍贵影像回忆的人。",
      },
      {
        key: "difference",
        question: "和其他行程有什么不同？",
        answer:
          "本行程全部使用专业级拍摄设备。曾为世界各地客人拍摄的专业摄影师，会细致考虑构图、光线、时间段、快门速度等每一个细节。我们重视的不是常见的量产型社交媒体视频，而是只有在这里才能拍到的空气感和世界观。",
      },
      {
        key: "qualityGuarantee",
        question: "什么是拍摄条件保障？",
        answer:
          "我们会根据当天的天气和海况判断拍摄条件。如果不适合拍摄，将免费取消或建议改期。",
      },
      {
        key: "whyCreated",
        question: "为什么创立这个行程？",
        answer:
          "宫古岛有很多很棒的旅行项目，但我们认为还缺少一个真正重视拍摄质量的行程。宫古岛的大海、光线和空气感拥有非常大的潜力。我们希望最大限度展现这些魅力，打造只有在这里才能拍摄到的特别体验。",
      },
      {
        key: "ageLimit",
        question: "有年龄限制吗？",
        answer:
          "除冲浪体验外，为了维持行程的世界观和体验概念，本行程仅限20岁至40岁的客人参加。",
      },
      {
        key: "children",
        question: "儿童可以参加吗？",
        answer:
          "非常抱歉。除冲浪体验外，本行程是以成人向体验和拍摄为概念设计的，因此不接受儿童参加。",
      },
      {
        key: "delivery",
        question: "照片和视频什么时候可以收到？",
        answer:
          "拍摄数据当天可以通过 AirDrop 交付。需要编辑的数据将在2至3天内通过在线下载链接发送。",
      },
      {
        key: "rain",
        question: "下雨天怎么办？",
        answer:
          "我们会根据当天的海况和天气进行判断。如果认为难以保证足够的拍摄质量，行程可能会取消或改期。此情况下不会产生取消费用。",
      },
      {
        key: "pickup",
        question: "有接送服务吗？",
        answer: "宫古岛内的酒店和机场周边可以接送。",
      },
      {
        key: "bring",
        question: "需要带什么？",
        answer: "请准备泳衣、毛巾、凉鞋和防晒用品。",
      },
      {
        key: "cancel",
        question: "关于取消费用",
        answer:
          "请查看各行程详情页面的注意事项。如果因天气或海况原因由我们取消行程，将不会产生取消费用。",
      },
      {
        key: "payment",
        question: "关于付款",
        answer: "请在行程当天以现金支付。目前仅接受现金付款。",
      },
    ],
    cta: {
      lines: [
        "如有其他问题，欢迎随时咨询。",
        "可通过 LINE 或 Instagram DM 进行预约和咨询。",
        "通常会在1小时内回复。若正在带团，将在行程结束后尽快回复。",
      ],
      buttons: {
        line: "通过 LINE 咨询",
        instagram: "通过 Instagram 咨询",
      },
    },
  },

  한국어: {
    hero: {
      subTitle: "FAQ",
      title: "자주 묻는 질문",
      description:
        "처음 참여하시는 분들도 안심하실 수 있도록 자주 받는 질문을 정리했습니다.",
    },
    openLabel: "FAQ 열기",
    items: [
      {
        key: "recommended",
        question: "어떤 분께 추천하나요?",
        answer:
          "사진과 영상 퀄리티를 중요하게 생각하는 분, 여자 여행, 혼자 여행, 특별한 미야코지마 경험을 원하는 분, 일상을 잠시 잊고 비일상적인 체험을 즐기고 싶은 분께 추천합니다. 일반적인 관광 투어가 아니라 아름다운 풍경과 특별한 장소에서 오래 남을 추억을 사진과 영상으로 남기고 싶은 분들을 위한 투어입니다.",
      },
      {
        key: "difference",
        question: "다른 투어와 무엇이 다른가요?",
        answer:
          "저희 투어는 모든 촬영에 전문가용 장비를 사용합니다. 전 세계 게스트를 촬영해 온 프로 카메라맨이 구도, 빛, 시간대, 셔터스피드 등 세부적인 부분까지 신경 써서 촬영합니다. SNS에서 흔히 볼 수 있는 양산형 영상이 아니라, 이곳에서만 담을 수 있는 분위기를 중요하게 생각합니다.",
      },
      {
        key: "qualityGuarantee",
        question: "촬영 컨디션 보장이란 무엇인가요?",
        answer:
          "당일 날씨와 바다 상황을 확인해 촬영 컨디션이 충분하지 않다고 판단되면 취소 수수료 없이 취소하거나 일정 변경을 안내합니다.",
      },
      {
        key: "whyCreated",
        question: "왜 이 투어를 만들었나요?",
        answer:
          "미야코지마에는 훌륭한 투어가 많지만, 촬영 퀄리티에 이 정도로 집중한 투어는 많지 않다고 느꼈습니다. 미야코지마의 바다, 빛, 공기감은 더 큰 가능성을 가지고 있습니다. 그 매력을 최대한 끌어내고, 이곳에서만 찍을 수 있는 경험을 만들고 싶어 이 투어를 시작했습니다.",
      },
      {
        key: "ageLimit",
        question: "나이 제한이 있나요?",
        answer:
          "서핑 체험을 제외한 투어는 체험의 분위기와 콘셉트를 유지하기 위해 20세부터 40세까지의 고객님을 대상으로 하고 있습니다.",
      },
      {
        key: "children",
        question: "아이도 참여할 수 있나요?",
        answer:
          "죄송합니다. 서핑 체험을 제외한 투어는 성인을 위한 체험과 촬영을 콘셉트로 하고 있어 어린이의 참여는 어렵습니다.",
      },
      {
        key: "delivery",
        question: "사진과 영상 데이터는 언제 받을 수 있나요?",
        answer:
          "촬영 데이터는 당일 AirDrop으로 전달 가능합니다. 편집이 필요한 데이터는 2~3일 이내에 온라인 다운로드 URL로 보내드립니다.",
      },
      {
        key: "rain",
        question: "비가 오면 어떻게 되나요?",
        answer:
          "당일 해상 상황과 날씨를 확인한 뒤, 충분한 촬영 퀄리티로 안내하기 어렵다고 판단될 경우 투어를 취소하거나 일정을 변경할 수 있습니다. 이 경우 취소 수수료는 발생하지 않습니다.",
      },
      {
        key: "pickup",
        question: "픽업 서비스가 있나요?",
        answer: "미야코지마 내 호텔 및 공항 주변까지 픽업 가능합니다.",
      },
      {
        key: "bring",
        question: "준비물은 무엇인가요?",
        answer: "수영복, 수건, 샌들, 선크림을 준비해 주세요.",
      },
      {
        key: "cancel",
        question: "취소 수수료에 대해",
        answer:
          "각 투어 상세 페이지의 주의사항을 확인해 주세요. 날씨 등의 영향으로 저희 측에서 투어를 취소하는 경우 취소 수수료는 무료입니다.",
      },
      {
        key: "payment",
        question: "결제는 어떻게 하나요?",
        answer:
          "투어 당일 현금으로 결제해 주세요. 현재는 현금 결제만 가능합니다.",
      },
    ],
    cta: {
      lines: [
        "기타 궁금한 점은 편하게 문의해 주세요.",
        "LINE 또는 Instagram DM으로 예약 및 상담을 받고 있습니다.",
        "보통 1시간 이내에 답변드립니다. 투어 중일 경우 종료 후 바로 연락드리겠습니다.",
      ],
      buttons: {
        line: "LINE으로 상담하기",
        instagram: "Instagram으로 상담하기",
      },
    },
  },
};
